const blackListProps = {};
export { blackListProps as default };
//# sourceMappingURL=blackListProps.js.map